export default __webpack_public_path__ + "static/commercial-ampm@1x-455509b44eca10a070c11c330bb6d4b0.jpg";